import React from "react";
import Snap from "snapsvg-cjs";

import oranguhang from "../images/svg/oranguhang02.svg";
import "./Animation.css";

// mina is not exported from snapsvg-cjs
const mina = window.mina;

class Oranguhang extends React.Component {

	componentDidMount() {
		// Set ready to false
		this.props.setReadyState(false);
		// Allows to assign this to an attr in parent
		this.props.onRef(this);
		// Load SVG into the component
		this.svg = Snap(document.querySelector("#oranguhang"));
		Snap.load(
			oranguhang,
			function (data) {
				this.svg.append(data);
				// Set ready to true
				this.props.setReadyState(true);
			}.bind(this),
		);
	}

	detect_clash(m, fixedCircle, handPath) {
		var samples = 100;
		var length = handPath.getTotalLength();
		for (var i = 0; i < samples; i++) {
			var p = handPath.getPointAtLength(i / samples * length);
			var cx = Number(fixedCircle.attr("cx"));
			var cy = Number(fixedCircle.attr("cy"));
			var r = Number(fixedCircle.attr("r"));
			var x = m.x(p.x, p.y);
			var y = m.y(p.x, p.y);
			if ((x - cx) ** 2 + (y - cy) ** 2 < (r + 1.2 ) ** 2) {
				return true;
			}
		}
		return false;
	}

	get_hand_angle(m, hand) {
		var fixedCircle = Snap.select("#oranguhang #fixed-circle");
		var handPath = Snap.select("#oranguhang #hand-path"); //NOTE: add "hand-path" to hand shape
		var handPivot = Snap.select("#oranguhang #hand-pivot"); //NOTE: additional circle for pivot
		// Handles SVG hidden before animation end
		// e.g. if user clicks "back" during animation
		if (!fixedCircle || !handPath || !handPivot) {
			return null;
		}
		while (this.detect_clash(m, fixedCircle, handPath)) {
			// Rotate anti-clockwise until no clash
			m = m.rotate(-.2, Number(handPivot.attr("cx")), Number(handPivot.attr("cy")));
		}
		while (!this.detect_clash(m, fixedCircle, handPath) && m.split().rotate < 0.) {
			// Rotate back until clash again
			hand.attr({ transform: m });
			var angle = m.split().rotate;
			m = m.rotate(+.2, Number(handPivot.attr("cx")), Number(handPivot.attr("cy")));
		}
		return angle || 0.;
	}

	animate() {
		// Select appropriate groups
		var gear = Snap.select("#oranguhang #gear");
		var hand = Snap.select("#oranguhang #hand");
		var rail = Snap.select("#oranguhang #rail");
		var gearAnchor = Snap.select("#oranguhang #gear-fixed");
		var magicSlipHeight = 86;
		var totalHeight = 100;
		var magicEndHeight = 62;
		var handPivot = Snap.select("#oranguhang #hand-pivot");
		var angle = 0;
		var gearAngle = 0;
		var gearX = Number(gearAnchor.attr("cx"));
		var gearY = Number(gearAnchor.attr("cy"));

		// Lower back down
		var lowerAnimation = () => Snap.animate(
			0,
			1,
			function (step) {
				var m = new Snap.Matrix();
				var n = new Snap.Matrix();
				var h = -totalHeight - (magicEndHeight-totalHeight) * step;
				m.translate(0, h);
				rail.attr({ transform: m });
				hand.attr({ transform: m });
				gear.attr({ transform: n.rotate(gearAngle, gearX, gearY) });
				gearAngle = h * 3.87;
			}.bind(this),
			1000,
			mina.easeinout,
			function () {
				// Animation complete
				this.props.onAnimationEnd();
			}.bind(this)
		);
		// Return hand to horizontal position
		var handReturnAnimation = (angle) => Snap.animate(
			0,
			1,
			function (step) {
				var m = new Snap.Matrix();
				var n = new Snap.Matrix();
				//m.rotate(step*360, 59.87, 28.38);
				var h = -magicSlipHeight - (totalHeight-magicSlipHeight) * step;
				var newAngle = angle * (1.-step);
				m.translate(0, h);
				rail.attr({ transform: m });
				hand.attr({ transform: m.rotate(newAngle, Number(handPivot.attr("cx")), Number(handPivot.attr("cy"))) });
				gear.attr({ transform: n.rotate(gearAngle, gearX, gearY) });
				gearAngle = h * 3.87;
			}.bind(this),
			1000,
			mina.bounce,
			function () {
				lowerAnimation();
			}
		);
		// Raise animate to the `magicSlipHeight` (hard coded)
		// i.e. the height at which hand would slip back over fixed
		var raiseAnimation = () => Snap.animate(
			0,
			1,
			function (step) {
				var m = new Snap.Matrix();
				var n = new Snap.Matrix();
				//m.rotate(step*360, 59.87, 28.38);
				var h = -magicSlipHeight * step;
				m.translate(0, h);
				rail.attr({ transform: m });
				hand.attr({ transform: m.rotate(angle, Number(handPivot.attr("cx")), Number(handPivot.attr("cy"))) });
				angle = this.get_hand_angle(m, hand);
				// Handles SVG hidden before animation end
				// e.g. if user clicks "back" during animation
				if (angle==null) { 
					return; 
				}
				gear.attr({ transform: n.rotate(gearAngle, gearX, gearY) });
				gearAngle = h * 3.87 ;
				//console.log(step);
			}.bind(this),
			3000,
			mina.easeout,
			function () {
				handReturnAnimation(angle);
			}
		);
		// Start the animation sequence
		raiseAnimation();

	}

	render() {
		return (
			<svg id="oranguhang"
				viewBox="0 0 220 300"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="xMidYMid meet">
			</svg>
		);
	}
}

export default Oranguhang;




// WEBPACK FOOTER //
// ./src/animation/Oranguhang.js